import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-80e76024"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-container" }
const _hoisted_2 = { class: "text-primary-language" }
const _hoisted_3 = {
  key: 0,
  class: "text-secondary-language"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-item-container", { 'first-form-item': _ctx.form_item_order === 0 && _ctx.layout_mode === 'all_on_one_page' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.text_label_lang1), 1),
      (_ctx.bilingue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.text_label_lang2), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}